import AddRemoveItems from "./AddRemoveItems";
import BodyText from "./BodyText";
import Box from "./Box";
import DropdownSection from "./DropdownSection";
import GarmentWithIcon from "./GarmentWithIcon";
import PropTypes from "prop-types";
import React from "react";
import Text from "./Text";
import ThreeColumnFormRow from "./ThreeColumnFormRow";
import TwoColumnFormRow from "./TwoColumnFormRow";

function ItemRow({
  item,
  quantity,
  incrementItem,
  decrementItem,
  addItem,
  removeItemsById,
  colNo,
}) {
  return (
    <Box
      backgroundColor="#ECECEC"
      mb="9px"
      borderRadius="4px"
      py={[20, null, 17, null]}
      minHeight={65}
    >
      {colNo === 3 ? (
        <ThreeColumnFormRow
          col1={<GarmentWithIcon name={item.name} icon={item.icon} />}
          col2={
            <Text
              fontWeight={700}
              fontFamily="bold"
              fontSize={[14, 16, 22, 22]}
            >
              £{item.value ? item.value : 0}
            </Text>
          }
          col3={
            <AddRemoveItems
              quantity={quantity}
              incrementItem={incrementItem}
              decrementItem={decrementItem}
              addItem={addItem}
              removeItemsById={removeItemsById}
              item={item}
            />
          }
        />
      ) : (
        <TwoColumnFormRow
          col1={<GarmentWithIcon name={item.name} icon={item.icon} />}
          col2={
            <AddRemoveItems
              quantity={quantity}
              incrementItem={incrementItem}
              decrementItem={decrementItem}
              addItem={addItem}
              removeItemsById={removeItemsById}
              item={item}
            />
          }
        />
      )}
      {item.description && (
        <Box px={["12px", 40, null, null]} width={[null, null, "70%", null]}>
          <DropdownSection
            heading="Detail"
            content={<BodyText py={15}>{item.description}</BodyText>}
            opacityRollover
          />
        </Box>
      )}
    </Box>
  );
}

ItemRow.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    icon: PropTypes.string.isRequired,
    value: PropTypes.number,
  }).isRequired,
  quantity: PropTypes.number.isRequired,
  colNo: PropTypes.number.isRequired,
};

export default ItemRow;
